import { render } from "./activeSaleInfo.vue?vue&type=template&id=ffe1f296&scoped=true"
import script from "./activeSaleInfo.vue?vue&type=script&lang=js"
export * from "./activeSaleInfo.vue?vue&type=script&lang=js"

import "./activeSaleInfo.vue?vue&type=style&index=0&id=ffe1f296&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffe1f296"]])

export default __exports__